import { IAppState } from '../../redux';
import { TBusinessAppointmentsState } from '../../types/businessType';

export function businessAppointmentsDataSelector(state: IAppState): TBusinessAppointmentsState['data'] {
  return state.businessAppointments.data;
}
